import { useMutation, useQueryClient } from '@tanstack/react-query';

import { PermissionGateway } from '../gateways';
import { handleResponse } from '@/core/utils/response';
import { entityKeyFactory, folderKeyFactory } from '@/core/query-keys';

interface MutationProps {
  folder_id: string;
}

async function deletePermissions({ folder_id }: MutationProps) {
  return handleResponse(PermissionGateway.deleteMany({ folder_id }));
}

export function useDeletePermissions() {
  const client = useQueryClient();

  return useMutation(deletePermissions, {
    onSuccess: ({ folder_id }) => {
      client.invalidateQueries(entityKeyFactory.all);
      client.invalidateQueries(folderKeyFactory.byFolderId(folder_id));
    }
  });
}
